<div
  class="modal delete-modal-backdrop"
  style="display: block !important; background: #0000007a"
  id="content"
>
  <div class="modal-dialog delete-dialog">
    <div class="modal-content delete-dialog-content">
      <div class="delete-dialog-body">
        <div class="delete-dialog-icon">
          <img alt="" src="/assets/images/mcd-trash.svg" />
        </div>

        <div class="delete-dialog-title-row">
          <h4 class="delete-dialog-title">{{ headingTitle }}</h4>
        </div>

        <p class="delete-dialog-question" *ngIf="title">{{ title }}</p>
        <p class="delete-dialog-message" *ngIf="message">{{ message }}</p>
      </div>

      <div class="delete-dialog-footer">
        <button
          type="button"
          class="delete-btn delete-btn-cancel"
          (click)="closeDialog()"
        >
          {{ cancelButtonLabel }}
        </button>
        <button
          type="button"
          class="delete-btn delete-btn-confirm"
          (click)="delete()"
        >
          {{ confirmButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</div>
